import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { courseCatalogueData, dimensionSkill, getCoursesInformation, getSocialActivityDetail } from "../../redux/actions/APIs";
import { tagsCourse } from "../../redux/actions/Home";
import * as image from "../../resources/images";
import { getDimIcon, getSequnceSort } from "../../utils/helper";
import { SITEURLNAME } from "../../utils/Messages";
import { setCourseModal } from "../../redux/actions";
import { PATHS } from "../../utils";
import { useHint } from "react-bootstrap-typeahead";
const Developmental = ({ handleEnroll, loader }) => {
	const params = useParams();
	const dispatch = useDispatch();
	const history = useHistory();
	const { defaultChildData,
		tagsCouresData,
		dimSkillObj,
		courseCatalogData,
		loggedInUser
	} = useSelector((state) => state.collections);

	let ENV;
	if (window.location.hostname === "uat.d3q8d8fs329b3i.amplifyapp.com") {
		ENV = "UAT";
	} else if (window.location.hostname === SITEURLNAME.urlName) {
		ENV = "PROD";
	} else {
		ENV = "DEV";
	}

	const guserId = loggedInUser?.role?.name === "PARENT" ? loggedInUser?.id : params?.childId;

	const [dimIndex, setDimIndex] = useState(0);

	const [selectedIds, setSelectedIds] = useState([
		{ name: "tag", isActive: false, tagIds: [] },
		{ name: "Dimension", isActive: false, dimIds: [], skillIds: [] },
	])
	const [getAllCourse, setAllCourses] = useState([]);
	const [showCourseIds, setShowCourseIds] = useState([]);


	useEffect(() => {
		if (loggedInUser) {
			if (!tagsCouresData) {
				dispatch(tagsCourse(guserId));
			} if (!dimSkillObj) {
				dispatch(dimensionSkill(guserId));
			}
		}
	}, [loggedInUser, params]);
	console.log("Developmental : ",tagsCouresData, dimSkillObj );



	const selectAllSkill = (dimObj, mySkills) => {
		let tempSelectedIds = [...selectedIds]
		const dimKey = tempSelectedIds[1]?.dimIds?.findIndex((dimId) => dimId === dimObj?.id);
		if (dimKey === -1) {
			tempSelectedIds[1]?.dimIds.push(dimObj?.id);
		} else {
			tempSelectedIds[1]?.dimIds.splice(dimKey, 1);
		}

		getSequnceSort(mySkills)?.map((skill) => {
			let skillKey = tempSelectedIds[1]?.skillIds?.findIndex((skId) => skId === skill?.id);
			if (skillKey === -1) {
				tempSelectedIds[1]?.skillIds.push(skill?.id);
			} else {
				if (dimKey !== -1) {
					tempSelectedIds[1]?.skillIds.splice(skillKey, 1);
				}

			}
		})

		tempSelectedIds[1].isActive = true;
		tempSelectedIds[0].isActive = false;
		tempSelectedIds[0].tagIds = [];
		//  console.log("tempSelectedIds : ", tempSelectedIds, "---", myId);
		setSelectedIds(tempSelectedIds);
	}


	const handleSelectons = (type, myId, dimObj) => {
		let tempSelectedIds = [...selectedIds]
		if (type === "tag") {
			tempSelectedIds[0].isActive = true;
			const idKey = tempSelectedIds[0]?.tagIds?.findIndex((tagName) => tagName === myId);
			if (idKey === -1) {
				tempSelectedIds[0]?.tagIds.push(myId);
			} else {
				tempSelectedIds[0]?.tagIds.splice(idKey, 1)
			}
			tempSelectedIds[1].isActive = false;
			tempSelectedIds[1].skillIds = [];
		}
		else {
			tempSelectedIds[1].isActive = true;
			const idKey = tempSelectedIds[1]?.skillIds?.findIndex((skillId) => skillId === myId);
			if (idKey === -1) {
				tempSelectedIds[1]?.skillIds.push(myId);
			} else {
				tempSelectedIds[1]?.skillIds.splice(idKey, 1)
			}
			let skillCount = 0;
			dimObj?.skills?.map((skill, index) => {
				let skKey = tempSelectedIds[1]?.skillIds?.findIndex((skillId) => skillId === skill?.id);
				if (skKey !== -1) {
					skillCount++;
				}
			})

			if (dimObj?.skills?.length === skillCount) {
				tempSelectedIds[1]?.dimIds.push(dimObj.id);
			} else {
				let dimKey = tempSelectedIds[1]?.dimIds?.findIndex((dimId) => dimId === dimObj.id);
				if (dimKey !== -1) {
					tempSelectedIds[1]?.dimIds?.splice(dimKey, 1);
				}

			}

			tempSelectedIds[0].isActive = false;
			tempSelectedIds[0].tagIds = [];
		}
		//  console.log("tempSelectedIds : ", tempSelectedIds, "---", myId);
		setSelectedIds(tempSelectedIds);
	}

	const handleMostPopular = () => {
		let tempSelectedIds = [...selectedIds]
		tempSelectedIds[0].isActive = false;
		tempSelectedIds[0].tagIds = [];
		tempSelectedIds[1].isActive = false;
		tempSelectedIds[1].skillIds = [];
		setSelectedIds(tempSelectedIds);
	}

	useEffect(() => {

		let dataObj = {
			"popularCourse": false,
			"envName": ENV
		}
		if (selectedIds[0]?.isActive && selectedIds[0]?.tagIds?.length > 0) {
			dataObj.tags = selectedIds[0]?.tagIds;

		} else if (selectedIds[1]?.isActive && selectedIds[1]?.skillIds?.length > 0) {
			dataObj.skillIds = selectedIds[1]?.skillIds;
		} else {
			dataObj.popularCourse = true;
		}
		if (loggedInUser) {
			dispatch(courseCatalogueData(guserId, dataObj))
		}
	}, [loggedInUser, selectedIds])

	useEffect(() => {
		if (courseCatalogData?.records?.length > 0) {
			let courseArr = [];
			getSequnceSort(courseCatalogData?.records?.map((dim, index) => {

				getSequnceSort(dim?.skills?.map((skill, key) => {
					getSequnceSort(skill?.courses?.map((course, corKey) => {
						course.dimension = { name: dim?.name, id: dim?.id }
						course.skill = { name: skill?.name, id: skill?.id }
						courseArr?.push(course);
					}))
				}))
			}))
			setAllCourses(courseArr);

		}
	}, [courseCatalogData])

	const toggleAccordion = (index) => {
		setDimIndex(dimIndex === index ? null : index);
	}

	const courseDetail = (obj) => {
		let courseObj = { ...obj }
		obj.dimension.key = obj?.dimension?.id;
		obj.dimension.value = obj?.dimension?.name;
		obj.skillId = obj?.skill?.id;
		obj.skillName = obj?.skill?.name;
		console.log("courseDetail : ", obj);
		dispatch(setCourseModal(obj));
		//	console.log("courseDetail : ", obj);
	};

	//  console.log("courseCatalogData : ",selectedIds,courseCatalogData, !selectedIds[0]?.isActive && !selectedIds[1]?.isActives);

	// const handleEnroll = (courseObj) => {
	// 	if (loggedInUser?.children?.length > 1) {
	// 		dispatch(showModal({ type: "ChildEnrollmentPopUp", course: courseObj, }))
	// 	} else {
	// 		dispatch(enrollModal(courseObj));
	// 	}
	// }

	const handleShowMore = (courseId)=>{
		let getCourseIds = [...showCourseIds];
		const key = getCourseIds?.findIndex((corId, key)=> corId === courseId);
		if(key === -1){
			getCourseIds.push(courseId);
		}else{
			getCourseIds.splice(key, 1);
		}
		setShowCourseIds(getCourseIds);
	}

	const handleContinue = (courseObj) => {
			// courseObj.planId = myplan.id;
			dispatch(getSocialActivityDetail())
			dispatch(getCoursesInformation());
			// console.log("courseObj : ", courseObj);
			history.push({
				pathname: PATHS.STR_COURSE_DETAIL + "/" + courseObj?.id + "/" + courseObj?.currentModuleId,
				state: { course: courseObj }
			})
		}

	

	return (
		<>
			<div className="course_catalogfilstes pb-0">
				<h2>Want Your Child To Work On A Specific Developmental Area/Skill Set?</h2>
				<p className="p2 lighttextcolor mt-3" >Already know the kind of skills your child needs? Start by picking a growth area—like Social or Emotional—and then choose specific skills to see the best course matches. The right courses will appear dynamically below.</p>

				<div className="developmentarea">
					<div className="populattags">
						<ul>

							<li className="tagitems">
								<div className="Ansoptions" onClick={() => handleMostPopular()}
								>
									<label className="selAnslabel ">
										<span className="tagName">Most Popular Courses</span>
										<input type="checkbox" name="knowledgecheck" checked={!selectedIds[0]?.isActive && !selectedIds[1]?.isActive} />
										<span class="checkmark"></span>
									</label>
								</div>

							</li>
							{tagsCouresData?.records?.map((tag, index) => (
								<li className="tagitems" key={index}>
									<div className="Ansoptions" >
										<label className="selAnslabel ">
											<span className="tagName">{tag}</span>
											<input type="checkbox" name="knowledgecheck" checked={selectedIds[0]?.tagIds?.includes(tag)} onClick={() => handleSelectons("tag", tag)} />
											<span class="checkmark"></span>
										</label>
									</div>
								</li>
							))}
						</ul>
					</div>
					<div className="dimtagcontainer">
						{getSequnceSort(dimSkillObj?.records)?.map((dim, index) => (
							<div className="dimensiontagsList mt-4 py-2" key={index}>
								<h3 className="flexone pb-4">
									<span className="flexthree">
										<span className="mr-4">{getDimIcon(dim)}</span> {dim?.name}</span>
									<span
										class="dropdwnicon pointer flexfive"
										href={"#showDimensionSkill" + index}
										aria-expanded={dimIndex === index}
										onClick={() => toggleAccordion(index)}
									><i class="fa-regular fa-chevron-down"></i>
									</span>
								</h3>
								<ul className={`mt - 3 panel-collapse collapse ${dimIndex === index ? "show" : ""}`}
									id={"#showDimensionSkill" + index}>
									<li className={`dimtagitems ${selectedIds[1]?.dimIds?.includes(dim?.id) && "activedimtag"} pointer`}
										onClick={() => selectAllSkill(dim, dim?.skills)}>
										<span>Select All</span>
									</li>
									{getSequnceSort(dim?.skills)?.map((skill, skey) => (
										<li className={`dimtagitems ${selectedIds[1]?.skillIds?.includes(skill?.id) && "activedimtag"} pointer`} key={skey}
											onClick={() => handleSelectons("dimensions", skill?.id, dim)} >
											<span>{skill?.name}</span>
											{
												selectedIds[1]?.skillIds?.includes(skill?.id) && (<span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>)
											}
										</li>
									))}
								</ul>
							</div>
						))}
					</div>

				</div>
			</div>
			<div className="courselistcontainer pdt-4">
				<div className="mycourselist">
					<h2>Courses For {loggedInUser?.role?.name === "PARENT" ? "Your Child" : "You"}</h2>
					<p className="p1 lighttextcolor">Browse through our courses and find the best fit. Filter out courses from above.</p>
				</div>
				<div className="mycoursecataloglist pdt-4">
					{getSequnceSort(getAllCourse)?.map((course, index) => (
						<div className={`coursecard coursecatcard min-width-100  ${course.dimension.name}DimCard`} ke={index}>
							<div className="skils_dimName">
								<div className="cardcimensionicon">
									{/* <img src={image.courselevel3} alt="dimicon" /> */}
									{console.log("course")}
									{getDimIcon(course?.dimension?.name)}
								</div>
								<div className="flexone">
									<ul className="flextwo">
										<li className="flexfive"><span><img src={image.dimension3d} alt="Dimension_icon" /></span>{course?.dimension?.name}</li>
										<li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon" /> </span>{course?.skill?.name}</li>
									</ul>
								</div>
							</div>
							<div className="course_name pt-0 pb-0">
								<h3>{course?.name}</h3>
							</div>
							<div className="course_objective ">
								<h3 className=" mb-3 pb-2 pt-0">📊 Course Objectives:</h3>
								<ul>
									{getSequnceSort(course?.objectives)?.map((objective, objKey) => (
									(objKey < 3 || showCourseIds?.includes(course?.id)) && (
											<li className="lighttextcolor mb-3 flextwo" key={objKey}>
											<span>
											<img src={image.checkicons} alt="check" />
											<strong className="mr-1">
											
											{objective?.content.split(":")[0]}:</strong>
											{objective?.content.split(":")[1]}

											</span>
										</li>
										)
										
									))}
								</ul>
								<p onClick={()=>handleShowMore(course?.id)}><a href="javascript:void(0)">
									{showCourseIds?.includes(course?.id) ? "Show Less" : "Show More"}</a></p>
							</div>

							<div className="coursecard_footer flexone">
								<div className="module_count lighttextcolor">
									<span>Modules: {course?.totalModules}</span><span>lessons: {course?.totalLesson}</span>
								</div>
								<div className="cardbutton_footer">
									{/* <button 
										className="mybutton learnmore" 
										onClick={() => handleContinue(course)}
									>Explore <i class="fa-regular fa-angle-right ml-1"></i></button> */}
									<button 
										className="mybutton learnmore" 
										onClick={() => courseDetail(course)}
									>Learn More <i class="fa-regular fa-angle-right ml-1"></i></button>
									{loader === course?.id ? (
										 <button
												className=" mybutton"
												key={Math.random()}
												disabled
											>
												<span className="RounAnimation mr-1"></span>{" "}
												Please Wait...
										</button>
									) : (
										<>
											{course?.isEnrolled ? (
												<span>
													<button className="enrolled mybutton learnmore">Enrolled</button>
												</span>
												
											) : (
												<button 
													className="mybutton" 
													onClick={() => handleEnroll(course)}
												><i className="fa-solid fa-paper-plane mr-1"></i> Enroll Now</button>
											)}
										</>
									)}
									
								</div>
							</div>
						</div>
					))}
				</div>
			</div>

		</>
	);
}
export default Developmental;